import * as React from 'react'

const SvgPaintBrushIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.019 14.481l-3.644-3.65V8.125a.625.625 0 00-.181-.444l-6.25-6.25a.625.625 0 00-.888 0L1.431 7.056a.625.625 0 000 .888l6.25 6.25a.625.625 0 00.444.181h2.713l3.643 3.65a2.501 2.501 0 003.538-3.537v-.007zM3.75 6.506l1.431 1.438.888-.888L4.63 5.625l.994-.994L8.306 7.32l.888-.888L6.506 3.75l.994-.994 4.119 4.119-4.744 4.744L2.756 7.5l.994-.994zm13.381 10.625a1.25 1.25 0 01-1.762 0l-3.832-3.825a1.124 1.124 0 00-.443-.181H8.38l-.625-.625L12.5 7.756l.625.625v2.713c0 .164.066.32.181.437l3.825 3.838a1.25 1.25 0 010 1.762z"
      fill="#163250"
    />
  </svg>
)

export default SvgPaintBrushIcon
